import { display } from '../../tools/display';
export var TAG_SIZE_LIMIT = 200;
export function buildTags(configuration) {
    var env = configuration.env, service = configuration.service, version = configuration.version;
    var tags = [];
    if (env) {
        tags.push(buildTag('env', env));
    }
    if (service) {
        tags.push(buildTag('service', service));
    }
    if (version) {
        tags.push(buildTag('version', version));
    }
    return tags;
}
export function buildTag(key, rawValue) {
    // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax.
    var valueSizeLimit = TAG_SIZE_LIMIT - key.length - 1;
    var sanitizedValue = rawValue
        .toLowerCase()
        .slice(0, valueSizeLimit)
        .replace(/[^a-z0-9_:./-]/g, '_');
    if (sanitizedValue !== rawValue) {
        display.warn(key + " value doesn't meet tag requirements and will be sanitized");
    }
    return key + ":" + sanitizedValue;
}
//# sourceMappingURL=tags.js.map